<template>
  <div>
    <v-text-field
      v-if="type === 'number'"
      v-model.number="internalValue"
      :disabled="disabled"
      :readonly="readonly"
      :filled="disabled"
      :error="!disabled && invalid"
      :append-icon="icon"
      :class="`with-icon-${icon}`"
      outlined
      dense
      type="number"
      hide-details
      @input="$emit('edited')"
      @change="$emit('edited')"
    ></v-text-field>
    <v-text-field
      ref="currency"
      v-else-if="type === 'ca'"
      v-model="currencyValue"
      v-currency="{currency: null, allowNegative: false}"
      placeholder="0"
      :disabled="disabled"
      :readonly="readonly"
      :filled="disabled"
      :error="!disabled && invalid"
      :append-icon="icon"
      :class="`with-icon-${icon}`"
      outlined
      dense
      hide-details
      @input="$emit('edited')"
      @change="$emit('edited')"
    />
    <v-text-field
      v-else
      v-model="internalValue"
      :disabled="disabled"
      :readonly="readonly"
      :filled="disabled"
      :error="!disabled && invalid"
      :append-icon="icon"
      :class="`with-icon-${icon}`"
      outlined
      dense
      hide-details
      @input="$emit('edited')"
      @change="$emit('edited')"
    >
    </v-text-field>
  </div>
</template>

<script>
const DEFAULT_CA_VALUE = '0,00'
import { setValue } from "vue-currency-input"
export default {
  name: 'EntryFormInput',
  props: {
    value: {required: true},
    type: {required: true},
    icon: {required: false},
    invalid: {type: Boolean, required: false, default: false},
    disabled: {type: Boolean, required: false, default: false},
    readonly: {type: Boolean, required: false, default: false}
  },
  data: () => ({
    currencyValue: null
  }),
  watch: {
    currencyValue (value) {
      const valueToEmit = this.$ci.parse(value || DEFAULT_CA_VALUE, {currency: null, allowNegative: false}).toString()
      this.$emit('input', valueToEmit)
    },

    // sub total readonly usecase
    // We need to update currencyValue when value prop change
    value (value) {
      const currentCurrencyValue = this.$ci.parse(this.currencyValue, {currency: null, allowNegative: false}).toString()
      // we want to avoid multiple re render
      if (this.type === 'ca' && value !== currentCurrencyValue) {
        setValue(this.$refs.currency, this.value)
      }
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    if (this.type === 'ca') {
      setValue(this.$refs.currency, this.value)
    }
  }
}
</script>
